import { BackendError } from "@/lib/backend";

function detailMessage(bodyText: string): string | null {
  try {
    const parsed = JSON.parse(bodyText) as { detail?: unknown };
    if (typeof parsed.detail === "string" && parsed.detail.trim()) {
      return parsed.detail.trim();
    }
    if (
      parsed.detail
      && typeof parsed.detail === "object"
      && "message" in parsed.detail
      && typeof parsed.detail.message === "string"
      && parsed.detail.message.trim()
    ) {
      return parsed.detail.message.trim();
    }
  } catch {
    return null;
  }
  return null;
}

export function backendErrorMessage(
  error: unknown,
  fallback: string,
): string {
  if (!(error instanceof BackendError) || !error.bodyText) return fallback;
  return detailMessage(error.bodyText) ?? fallback;
}
